export default __webpack_public_path__ + "static/media/awsathenalogo.3c979be0.png";